import React from "react";
import { useAuth } from "contexts/AuthProvider";
import { ConsentForm } from "./ConsentForm";
import { hasUpdatedTerms } from "./legalContent";

const MycorrLogo = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path
      d="M24 16V32L40 40V8L24 16ZM24 16L8 8V32"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinejoin="bevel"
    />
  </svg>
);

export const ConsentModal = () => {
  const { tosAccepted, ppAccepted, logout } = useAuth();

  if (tosAccepted && ppAccepted) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/40">
      <div
        className="relative bg-bg border border-border rounded-app shadow-lg w-full max-w-120 mx-4 max-h-[90vh] overflow-y-auto overscroll-none"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 flex flex-col gap-6">
          <div className="flex flex-col items-center gap-3 text-center">
            <MycorrLogo />
            <h2 className="text-lg font-semibold text-fg">
              {hasUpdatedTerms ? "Updated Terms" : "Terms of Service"}
            </h2>
            <p className="text-xs text-fg-muted leading-relaxed">
              {hasUpdatedTerms
                ? "We've updated our terms. Please review to continue."
                : "Please review and accept to continue"}
            </p>
          </div>

          <ConsentForm onAccepted={() => {}} compact />

          <div className="text-center">
            <button
              onClick={logout}
              className="text-xs text-fg-muted hover:text-fg cursor-pointer bg-transparent border-none"
            >
              Log out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
